import { MCLPopup } from "./mcl-popup";
import { el } from "./utils";

export const youtubePopups = () => {
    const triggers = document.querySelectorAll<HTMLButtonElement>('[data-yt-id]');

    if (triggers.length === 0) return;

    const popup = createPopup();
    const iframe = popup.popup.querySelector<HTMLIFrameElement>('iframe');

    triggers.forEach(trigger => {
        const ytId = trigger.dataset.ytId;
        if (!ytId) return;

        trigger.addEventListener('click', (e: Event) => {
            iframe?.setAttribute('src', `https://www.youtube.com/embed/${ytId}?autoplay=true`);
            popup.open(e);
        });
    });

    window.addEventListener('mcl-popup:mcl-yt-video-popup:closed', () => {
        iframe?.setAttribute('src', '');
    })

    function createPopup() {
        const popup = el<HTMLDivElement>('div', {
            class: 'mcl-popup',
            id: 'mcl-yt-video-popup',
        });
        const wrapper = el('div', { class: 'mcl-popup__wrapper' });
        const backdrop = el('div', { class: 'mcl-popup__backdrop' });
        const popupBody = el('div', { class: 'mcl-popup__body' });
        const closeButton = el('button', {
            class: 'mcl-popup__close',
            html: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16"><path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/></svg>'
        });

        const iframe = el('iframe', {
            src: '',
            frameborder: '0',
            allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; web-share',
            referrerpolicy: 'strict-origin-when-cross-origin',
            allowfullscreen: '1'
        });

        popupBody.append(closeButton, iframe);
        wrapper.append(backdrop, popupBody);
        popup.appendChild(wrapper);

        document.body.appendChild(popup);
        return new MCLPopup(popup);
    }
}